export class FrameDTO{
    id!: number;
    name?: string;
   frameMaterial: number[] = [];
  partner: number[] = [];
}